module.exports = __webpack_public_path__ + "59bff7ee2abb48f39a7f8b5474560f34.svg";